/* ==========================================================================
   NSG Framework
   Component: nsg-inspiration-gallery
   Version: 1.0
   ========================================================================== */

(() => {
  'use strict';

  const sections = document.querySelectorAll('.nsg-ig');

  if (!sections.length) return;

  sections.forEach((section) => {

    const cards = section.querySelectorAll('.nsg-ig__card');

    cards.forEach((card) => {

      card.addEventListener('mouseenter', () => {
        card.classList.add('is-active');
      });

      card.addEventListener('mouseleave', () => {
        card.classList.remove('is-active');
      });

      card.addEventListener('focusin', () => {
        card.classList.add('is-active');
      });

      card.addEventListener('focusout', () => {
        card.classList.remove('is-active');
      });

    });

    /* Animación de aparición */

    if ('IntersectionObserver' in window) {

      const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          if (!entry.isIntersecting) return;

          entry.target.classList.add('nsg-visible');

          observer.unobserve(entry.target);

        });

      }, {
        threshold: 0.15
      });

      cards.forEach((card, index) => {

        card.style.transitionDelay = `${index * 80}ms`;

        observer.observe(card);

      });

    } else {

      cards.forEach((card) => {
        card.classList.add('nsg-visible');
      });

    }

  });

})();